import { Component, Input } from '@angular/core';
import { PatientTreatmentForReview } from '../../models/patient-treatment.model';

import { HistoricTreatmentDetailRowComponent } from './historic-treatment-detail-row/historic-treatment-detail-row.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-historic-treatments-details',
  templateUrl: './historic-treatments-details.component.html',
  imports: [HistoricTreatmentDetailRowComponent, TranslateModule]
})
export class HistoricTreatmentsDetailsComponent {
  @Input() patientTreatmentsForReview: PatientTreatmentForReview[];
}
